<template>
    <div>

      <HeaderBreadcrumbs
        :items="[
          { label: 'Coupon', to: { name: 'coupon' } },
          { label: 'Add New' }
        ]"
        title="New Coupon"
      />

      <div class="tab-header flex items-center space-x-4 bg-white rounded-lg shadow-sm py-3 px-4 my-3">
        <div :class="['tab-item flex items-center', { 'text-blue-500 font-semibold': currentTab === 1 }]">
          <span :class="['font-bold rounded-full border p-1.5 mr-2 text-center w-9 h-9', { 'border-custom': currentTab === 1 }]">1</span>
          Coupon Details
        </div>
        <span class="text-gray-400">»</span>
        <div :class="['tab-item flex items-center', { 'text-blue-500 font-semibold': currentTab === 2 }]">
          <span :class="['font-bold rounded-full border p-1.5 mr-2 text-center w-9 h-9', { 'border-custom': currentTab === 2 }]">2</span>
          Coupon Code
        </div>
      </div>

      <div class="tab-content my-3 px-4 py-4 rounded-lg shadow-sm" v-if="currentTab === 1">
        <CouponDetails
             v-bind:form="form"
             v-on:updateError="updateError"
             :isCouponNameError="isCouponNameError"
             :isCouponDescriptionError="isCouponDescriptionError"
             :isCouponBayerNameError="isCouponBayerNameError"
             :isCouponPriceError="isCouponPriceError"
             :isError="isError"
             :isOfferError="isOfferError"

            />

      </div>
      <div class="tab-content mt-6 px-4 py-4 rounded-lg shadow-sm relative" v-if="currentTab === 2">
        <div class="bg-gray-300 left-0 absolute h-full z-10 top-0 rounded-lg w-full" v-if="isLoading">
          <div class="relative left-1/2 top-1/2 translate-x-0 -translate-y-1/2" >
            <div role="status">
            <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
            </svg>
            <span class="sr-only">Loading...</span>
        </div>
          </div>
        </div>
        <CouponCode
               v-bind:form="form"
               :isLoading="isLoading"
               @update-coupon-prefix="handleCouponPrefix"
               @update-coupons="handleUpdateCoupons"
          />
      </div>


      <div class="tab-navigation mt-6 flex justify-start space-x-2 mb-4">
        <button
          v-if="currentTab === 1"
          @click="validateAndNext"
          class="bg-blue-500 text-white px-4 py-2 rounded-lg"
        >
          Next
        </button>
        <button
          v-if="currentTab === 2"
          @click="save"
          class="bg-blue-500 text-white px-4 py-2 rounded-lg"
        >
          Save
        </button>
        <button
          v-if="currentTab === 1"
          @click="backTolist"
          class="bg-white text-gray-700 px-4 py-2 rounded-lg"
        >
          Cancel
        </button>
        <button
          v-else
          @click="cancel"
          class="bg-white text-gray-700 px-4 py-2 rounded-lg"
        >
          Cancel
        </button>
      </div>
    </div>
  </template>

  <script>
  import CouponDetails from "../../components/coupon/CouponDetails.vue";
  import CouponCode from "../../components/coupon/CouponCode.vue"
  import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue'
  import moment from "moment";
  import { EventBus } from '../../../src/event-bus'
  import { mapActions,mapState} from "vuex";

  export default {
    name: "CouponForm",
    components: {
      CouponDetails,
      CouponCode,
      HeaderBreadcrumbs
    },
    data() {
      return {
        currentTab: 1,
            form: {
                name: "",
                description: "",
                bayerName:"",
                is_active:false,
                valid_to: moment().toString(),
                valid_from:moment().toString(),
                couponPrice:"",
                couponPrefix:"",
                corporatePackage:'Corporate Package',
                selectedOfferName: [],
                platforms: [],
                offersPackage:[],
                couponCodes: [],
        },
        isCouponNameError: false,
        isCouponDescriptionError: false,
        isCouponBayerNameError:false,
        isCouponPriceError:false,
        isError:false,
        isOfferError:false
      };
    },
    computed: {
    ...mapState({
     // isError: (state) => state.coupons.isError,
      isLoading: (state) => state.coupons.isLoading,
      errorMessage: (state) => state.coupons.errorMessage,
      successMessage: (state) => state.coupons.successMessage,
    }),
  },
  watch: {
    errorMessage: function () {
      if (!this.errorMessage) return;
      EventBus.$emit('show-toast', {
        message: this.errorMessage,
        type: 'error',
      });
    },

    successMessage: function () {
    if (!this.successMessage) return;

    EventBus.$emit('show-toast', {
      message: this.successMessage,
      type: 'success',
    });

    if (this.isLoading) {
      this.$store.commit('coupons/setLoading', false);
    }
    this.backTolist()
  },
  },
    methods: {
      ...mapActions("coupons", [
      "couponsPost",
    ]),
      validateAndNext() {
        this.isCouponNameError = !this.form.name.trim();
        this.isCouponDescriptionError = !this.form.description.trim();
        this.isCouponBayerNameError = !this.form.bayerName.trim()
        this.isCouponPriceError = !this.form.couponPrice.toString().trim()
        this.isError = this.form.platforms.length === 0
        this.isOfferError = this.form.offersPackage.length === 0;
        if (
            !this.isCouponNameError &&
            !this.isCouponDescriptionError &&
            !this.isCouponBayerNameError &&
            !this.isCouponPriceError &&
            !this.isError &&
            !this.isOfferError
          ) {
          this.currentTab = 2;
        }
      },
      updateError({ field, status }) {
        if (field === "name") this.isCouponNameError = status;
        if (field === "description") this.isCouponDescriptionError = status;
        if (field === "bayer_name") this.isCouponBayerNameError = status;
        if (field === "coupon_price") this.isCouponPriceError = status;
        if (field === "platforms") this.isError = status;
        if (field === "offers") this.isOfferError = status;
      },
      backTolist() {
        this.$router.push("/coupons");
      },
      cancel() {
        this.currentTab = 1;
         this.form.couponCodes = []
      },
      reset() {
        this.form.name = "";
        this.form.description = "";
        this.form.bayerName = ""
        this.form.couponPrice = null
        this.isCouponNameError = false;
        this.isCouponDescriptionError = false;
        this.isCouponBayerNameError = false
      },
      handleUpdateCoupons(newCoupon) {
        this.form.couponCodes.push(newCoupon);
        this.$emit("update-coupons", this.form.couponCodes);
      },
        handleCouponPrefix(prefix) {
          this.form.couponPrefix =prefix
        },
      save()
      {
        const data = this.form
        if (this.form.couponCodes.length === 0) {
        alert("Coupon Codes cannot be empty. Please add at least one coupon code.");
        return;
      }

        const platformIds = data.platforms.map(p => p.id);
       const [offer] = data.offersPackage
       const offer_id = offer?.id
       const payload = {
          name:data.name,
          buyerName:data.bayerName,
          price:Number(data.couponPrice),
          description:data.description,
          platform:platformIds,
          offer_id: offer_id,
          prefixCode: data.couponPrefix,
          valid_to:data.valid_to,
          valid_from:data.valid_from,
          couponCodes:[...data.couponCodes],
          is_active:data.is_active
        }
        this.couponsPost(payload)

      }
    },
  };
  </script>

  <style scoped>
  .border-custom {
    border: 1px solid #3b82f6 !important;
  }

  </style>
